import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../order.service';
import { OrderModel } from '../model/order.model';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';


@Component({
  selector: 'app-order-edit',
  templateUrl: './order-summary.component.html',
  styleUrl: './order-summary.component.scss',
  standalone: false
})
export class OrderSummaryComponent implements DirtyCheck {
  title: string = "Order Summary";
  orderInfo: OrderModel = {};
  isFormDirty: boolean = false;
  totalCash: any;
  totalCard: any;
  totalVoucher: any;
  totalCompany: any;
  balance: any;
  totalRefund: any;
  payment_time: any;
  refund_payment_time: any;
  totalValue: number = 0;
  activePayments: { label: string; amount: number }[] = [];
  displayTax: number = 0;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private snackBarService: SnackBarService,) {

    let orderId = this.route.snapshot.paramMap.get('id');




    if (orderId !== null) {
      this.setOrderInfo(orderId);
    }
  }
  ngOnInit(): void {
    //  this.loadRating();    
  }

  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/report/orders']);

  }


  calculatePaymentTotals(payments: any[]): { cash: number, card: number, voucher: number, company: number, balance: number, refund: number, } {
    const totals = {
      cash: 0,
      card: 0,
      voucher: 0,
      company: 0,
      balance: 0,
      refund: 0
    };


    payments?.forEach(payment => {

      if (payment.is_repayment === 1) {
        // Add to refund total and skip other calculations
        totals.refund += payment.paid_amount || 0;
        return;
      }

      // Group by payment mode name
      switch (payment.payment_mode_name?.toLowerCase()) {
        case 'cash':
          totals.cash += payment.paid_amount || 0;
          break;
        case 'card':
          totals.card += payment.paid_amount || 0;
          break;
        case 'voucher':
          totals.voucher += payment.paid_amount || 0;
          break;
        case 'company':
          totals.company += payment.paid_amount || 0;
          break;
        case 'balance':
          totals.company += payment.paid_amount || 0;
          break;
      }
    });

    return totals;
  }

  /**
   * If tas is is null set an empty area info
   * if area id is not null call api to rtrive the info
   * @param orderId 
   */
  setOrderInfo(orderId: any): void {

    let response = this.orderService.getById(orderId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.orderInfo = response.data.orderDtls[0];
          this.totalValue = (this.orderInfo.total_amount ?? 0) - (this.orderInfo.bill_discount_amount ?? 0);
          this.displayTax = (this.orderInfo.total_tax ?? 0) - (this.orderInfo.bill_less_tax_amount ?? 0);

          const payments = this.orderInfo.order_payments || [];
          this.activePayments = this.calculateActivePayments(payments);
          const paymentTotals = this.calculatePaymentTotals(payments);

          // Assign to component variables
          this.totalCash = paymentTotals.cash;
          this.totalCard = paymentTotals.card;
          this.totalVoucher = paymentTotals.voucher;
          this.totalCompany = paymentTotals.company;
          this.balance = paymentTotals.balance;
          this.totalRefund = paymentTotals.refund;


          const originalPayment = payments.find(p => p.is_repayment === 0);
          this.payment_time = originalPayment?.payment_time?.slice(0, 16) || null;

          // Extract refund_payment_time (refund)
          const refundPayment = payments.find(p => p.is_repayment === 1);
          this.refund_payment_time = refundPayment?.payment_time?.slice(0, 16) || null;
          console.log('Payment Totals:', {
            cash: this.totalCash,
            card: this.totalCard,
            voucher: this.totalVoucher,
            company: this.totalCompany,
            balance: paymentTotals.balance,
            refund: paymentTotals.refund,
          });

          console.log('Order Info:', this.orderInfo);

          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = "Order Summary";
    return title;
  }



  calculateActivePayments(payments: any[]): { label: string; amount: number }[] {
    const paymentModeMap: { [key: number]: string } = {
      0: "Cash",
      1: "Card",
      2: "Voucher",
      3: "Company",
      4: "Discount",
      5: "Balance",
      6: "Coupon Balance",
      7: "Cash Out"
    };

    const totals: { [label: string]: number } = {};

    payments?.forEach(payment => {
      if (payment.is_repayment === 1) {
        return;
      }

      const mode = payment.payment_mode;
      if (mode !== null && mode !== undefined && paymentModeMap[mode] !== undefined) {
        const label = paymentModeMap[mode];
        const amount = payment.paid_amount || 0;
        totals[label] = (totals[label] || 0) + amount;
      }
    });

    return Object.keys(totals)
      .map(label => ({ label, amount: totals[label] }))
      .filter(item => item.amount > 0);
  }

  getOrderRemarks(orderInfo: any) {
    var remarks = "";
    if (
      orderInfo.remarks !== null &&
      orderInfo.remarks !== undefined &&
      orderInfo.remarks.length > 0
    ) {
      var rex = /\r\n|\n|\r/gm;
      remarks = "** " + orderInfo.remarks.replace(rex, "<br>");
    }
    return remarks;
  }


}


